import {spotheroDelete} from 'api';
import {sendSentryException} from 'utils/error-handling';

/**
 * Deletes a facility blackout
 *
 * @param facilityId - The id of the facility to delete the blackout for
 * @param blackoutId - The id of the blackout to delete
 *
 * @see '/api/v1/facilities/{facilityId}/blackouts/{blackoutId}/'
 */
const deleteBlackout = async (facilityId: number, blackoutId: number) => {
    try {
        await spotheroDelete(
            `facilities/${facilityId}/blackouts/${blackoutId}/`
        );
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default deleteBlackout;
